import { render, staticRenderFns } from "./row-default.vue?vue&type=template&id=1088d887&"
import script from "./row-default.vue?vue&type=script&lang=js&"
export * from "./row-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports